module.exports = {"title":"Enter your customer code <1 /> to access the offer portal"}